import React from "react";

import type { CurrencyCode } from "@app/types/currency";

import type { DepartureSummaryProps as DepartureSummaryProps } from "./departure-summary";

import { DepartureSummary } from "./departure-summary";

interface DeparturePassengerSummaryProps {
  departures: SummaryDeparture[];
  currency: CurrencyCode;
  passenger_first_names: string[];
}

export type SummaryDeparture = {
  id: string;
  origin_city: string | null;
  destination_city: string | null;
  charges_per_passenger: DepartureSummaryProps["charges_per_passenger"];
};

export const DeparturePassengerSummary: React.FC<
  DeparturePassengerSummaryProps
> = ({ currency, departures, passenger_first_names }) => (
  <>
    {departures.map((departure, idx) => {
      if (departure.charges_per_passenger.length === 0) {
        return null;
      }

      return (
        <DepartureSummary
          key={departure.id + idx}
          currency={currency}
          passenger_first_names={passenger_first_names}
          origin_city={departure.origin_city}
          destination_city={departure.destination_city}
          charges_per_passenger={departure.charges_per_passenger}
        />
      );
    })}
  </>
);
